<div
    class="report-tile"
    (click)="handleItem()"
    [ngClass]="{ placeholder: isPlaceholder, 'placeholder-light': isPlaceholderLight, disabled: isSaving, auto: auto }"
>
    <div class="report-header">
        <span>{{ item?.title }}</span>
        @if (guard.isAdmin && !auto && !isPlaceholder) {
            <button class="icon-delete" (click)="$event.stopPropagation(); delete.emit()"></button>
        }
    </div>
    <div class="report-content-container">
        <div class="top-container">
            <div class="report-body">
                <span class="file icon-document-pdf"></span>
                <div class="file-placeholder"></div>
            </div>
            <div class="report-footer">
                <div class="card-cell card-cell--full">
                    <label>{{ 'guidance.item.description' | translate }}</label>
                    <span>{{ item?.description }}</span>
                </div>
            </div>
        </div>
        <div class="report-footer">
            <div class="card-cell">
                <label>{{ 'responsible.item.responsibleType' | translate }}</label>
                <span>{{ 'generic.filter.' + responsibleType | translate }}</span>
            </div>
            <div class="card-cell">
                <label>{{ 'guidance.item.modifiedDate' | translate }}</label>
                <span>{{ item?.modifiedAt | date: 'M-d-y' }}</span>
            </div>
        </div>
    </div>
    @if (isSaving) {
        <app-loading-indicator size="100px" [delay]="delay" backgroundColor="transparent" />
    }
</div>
